import { useBundleFreshness } from '../hooks/useBundleFreshness';

/**
 * Non-blocking banner that appears when the running bundle is older
 * than the currently deployed one. Closes the "tab left open across a
 * deploy" failure mode (e.g. a sub who couldn't see the paper-check
 * opt-out because it shipped after they opened the form).
 */
export function UpdateBanner() {
  const { stale } = useBundleFreshness();

  if (!stale) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: '10px 16px',
        background: '#0D2152',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        flexWrap: 'wrap',
        fontSize: 14,
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      }}
    >
      <span>A newer version of this form is available.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: '#00B8EB',
          color: '#0D2152',
          border: 'none',
          borderRadius: 4,
          padding: '6px 14px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload to update
      </button>
    </div>
  );
}
